import { useContext, useEffect } from 'react';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import MetaHelmet from 'helpers/MetaHelmet';
import StepTemplate from '../StepTemplate';
import Step3Routes from './Step3Routes';
import step3Validation from './step3Validation';

const Step3 = () => {
  const {
    watch,
    errors,
    setError,
    clearErrors,
    setCurrentStep,
    trigger,
    watchedFields: {
      companyType,
      companyNumberLookupSuccess,
      billingAddressMatchesRegistered,
      propertyDuration,
    },
    postcodeSelectorsValidation: {
      dispatch,
      postcodeSearched,
      postcodeIsReset,
      hasPersistedData,
    },
  } = useContext(HookFormContext);

  useEffect(() => {
    setCurrentStep(3);
  }, []);

  // STEP VALIDATIONS SETUP
  const hookFormProps = {
    watch,
    errors,
    setError,
    clearErrors,
    trigger,
  };

  const validationFlags = {
    companyType,
    companyNumberLookupSuccess,
    postcodeSearched,
    postcodeIsReset,
    billingAddressMatchesRegistered,
    propertyDuration,
    hasPersistedData,
  };

  return (
    <>
      <MetaHelmet />
      <StepTemplate
        step={2}
        validate={step3Validation(hookFormProps, validationFlags)}>
        <Step3Routes
          dispatch={dispatch}
          postcodeSearched={postcodeSearched}
          hasPersistedData={hasPersistedData}
        />
      </StepTemplate>
    </>
  );
};

export default Step3;
